import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  Button,
  Container,
  Dialog,
  Typography,
  CircularProgress,
} from "@mui/material";
import styles from "./clientsConfirmationCreditsDialogStyles.js";
import useLogout from "../../../hooks/auth/authHook.js";
import { notification } from "../../../utils/Notifications.js";
import { removeCredits, addCredits, getUsers, getCredits } from "../../../api/userApi.js";

ClientsConfirmationCreditsDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};

export default function ClientsConfirmationCreditsDialog({
  onClose,
  open,
  credits,
  action,
  name,
  idUser,
  commentary,
  fetchClientCredits,
  setCommentary,
  setCredits
}) {
  const [logout] = useLogout();

  const [isLoading, setIsLoading] = useState(false);

  const handleDialogClose = (event, reason) => {
    if (reason === "backdropClick") {
      return;
    }
    onClose();
  };

  const handleUpdateCreditsClick = () => {
    if (isLoading) {
      return;
    }
    setIsLoading(true);

    if (action === "Remover") {
      removeCredits(idUser, credits, commentary)
        .then((response) => {
          if (response.data.status_Code === 200) {
            notification({ text: "Créditos removidos", type: "success" });
            getCredits()
              .then((response) => {
                if (response.data.status_Code === 200) {
                  fetchClientCredits();
                } else if (response.data.status_Code === 401) {
                  notification({
                    text: "Sesión expirada. Por favor, inicia sesión nuevamente.",
                    type: "error",
                  });
                  logout();
                } else {
                  notification({
                    text: "Error al obtener los usuarios",
                    type: "error",
                  });
                }
              })
              .catch(() => {
                notification({
                  text: "Error de conexión, revisa tu conexión a internet",
                  type: "error",
                });
              })
              .finally(() => {
                setIsLoading(false);
              });

            onClose();
          } else if (response.data.status_Code === 401) {
            notification({
              text: "Sesión expirada. Por favor, inicia sesión nuevamente.",
              type: "error",
            });
            logout();
          } else {
            notification({
              text: "Error al remover los créditos",
              type: "error",
            });
          }
        })
        .catch(() => {
          setIsLoading(false);
          notification({
            text: "Error de conexión, revisa tu conexión a internet",
            type: "error",
          });
        });
    }

    if (action === "Agregar") {
      addCredits(idUser, credits, commentary)
        .then((response) => {
          if (response.data.status_Code === 201) {
            notification({ text: "Créditos agregados", type: "success" });
            getCredits()
              .then((response) => {
                if (response.data.status_Code === 200) {
                  fetchClientCredits();
                } else if (response.data.status_Code === 401) {
                  notification({
                    text: "Sesión expirada. Por favor, inicia sesión nuevamente.",
                    type: "error",
                  });
                  logout();
                } else {
                  notification({
                    text: "Error al obtener los usuarios",
                    type: "error",
                  });
                }
              })
              .catch(() => {
                notification({
                  text: "Error de conexión, revisa tu conexión a internet",
                  type: "error",
                });
              })
              .finally(() => {
                setIsLoading(false);
              });

            onClose();
          } else if (response.data.status_Code === 401) {
            notification({
              text: "Sesión expirada. Por favor, inicia sesión nuevamente.",
              type: "error",
            });
            logout();
          } else {
            notification({
              text: "Error al agregar los créditos",
              type: "error",
            });
          }
        })
        .catch(() => {
          setIsLoading(false);
          notification({
            text: "Error de conexión, revisa tu conexión a internet",
            type: "error",
          });
        });
    }

    setCommentary('');
    setCredits(0);
  };

  return (
    <Dialog
      onClose={handleDialogClose}
      open={open}
      PaperProps={{ style: styles.dialog }}
    >
      <Container style={styles.mainContainer}>
        <Typography component="div" variant="h5" style={styles.title}>
          {action} créditos
        </Typography>
        <Typography component="div" variant="body1" style={styles.subtitle}>
          Se {action.toLowerCase()}án {credits} créditos al usuario {name}
        </Typography>
        { commentary && <Typography component="div" variant="body1" style={styles.subtitle}>
          <strong>Comentario: </strong>{commentary}
        </Typography>}

        <Container style={styles.buttonsContainer}>
          <Button
            variant="standard"
            color="primary"
            onClick={handleDialogClose}
            style={styles.cancelButton}
          >
            Cancelar
          </Button>
          <Button
            variant="contained"
            onClick={() => {
              handleUpdateCreditsClick();
            }}
            sx={styles.activeButton}
          >
            {isLoading ? (
              <CircularProgress size={24} style={styles.circularProgress} />
            ) : (
              action
            )}
          </Button>
        </Container>
      </Container>
    </Dialog>
  );
}
